<template>
	<section class="my-panel">
		<div class="level my-panel-heading">
			<div class="level-left">
				<h3 :class="['title', size]" v-text="heading" />
				<slot name="subtitle" />
			</div>
			<div class="level-right">
				<slot name="heading" />
			</div>
		</div>
		<div class="my-panel-body">
			<slot />
		</div>
	</section>
</template>

<script>
export default {
	props: {
		heading: {
			type: String,
			default: () => null
		},
		size: {
			type: String,
			default: "is-4"
		}
	}
};
</script>

<style lang="scss" scoped>
.my-panel {
	border: 1px solid #ccc;
	margin-bottom: 1em;
	&:first-of-type {
		margin-top: 1em;
	}
	&:last-of-type {
		margin-bottom: 0;
	}
}

.my-panel-heading {
	padding: 0.5em 1em;
	background: rgb(250, 250, 236);
	margin-bottom: 0;
}

.my-panel-body {
	padding: 1em;
}
</style>
